import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { Role, Event$, EventAttendee, CompletedTask_$reflection, User_$reflection, EventAttendee_$reflection, Event$_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, record_type, class_type, tuple_type, int32_type, array_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { FSharpSet__get_Count, isEmpty as isEmpty_1, ofArray as ofArray_1, contains as contains_1, toArray, remove, add, empty } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { int32ToString, comparePrimitives, createObj, numberHash, safeHash, equals, compareArrays } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { tryFind, sortWith, truncate, append, contains, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { unwrap, bind, defaultArg, map as map_1 } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { compareTo, now, compare, utcNow } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Report, Task, toastServerError, Event$ as Event$_1 } from "../ApiClient.jsx";
import { Result_Map } from "../fable_modules/fable-library-js.4.29.0/Result.js";
import { Array_groupBy } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { infoToast, successToast, errorToast } from "../Toasts.jsx";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "../Context.jsx";
import { SkeletonItem, Skeleton, PopoverSurface, PopoverTrigger, Popover, Caption2, Subtitle2, CardHeader, Card, MenuList, MenuItem, MenuPopover, MenuTrigger, Menu, DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, Tooltip, Field, Link, createTableColumn as createTableColumn_7, Text as Text$, Badge, Subtitle1, Avatar, Caption1, DialogSurface, DialogBody, DialogActions, Checkbox, Body1Strong, tokens, DialogContent, DialogTitle, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { QuestionRegular, PeopleAudienceRegular, DocumentArrowDownRegular, MoreVerticalRegular, SaveRegular, ClipboardTaskListLtrRegular, ChevronDownRegular, ChevronUpRegular, DismissFilled, CheckmarkFilled, LockClosedRegular, DocumentLockRegular, PersonDeleteRegular, DismissRegular, WarningFilled, DeleteRegular } from "@fluentui/react-icons";
import { TempSeq_mkOnChangeData, Checkbox_toBool } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { head, tail, isEmpty, empty as empty_2, singleton, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { toArray as toArray_1, tryHead, empty as empty_1, singleton as singleton_1, append as append_1, delay, toList, take, length } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { nb } from "date-fns/locale";
import { format as format_1 } from "date-fns";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { SortDirection } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { compareTo as compareTo_1, compare as compare_1 } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { dataGrid_items_Z6D8BD2B8 } from "../fable_modules/FS.FluentUI.3.0.0/Props2.fs.js";
import { tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { ByteArrayExtensions_SaveFileAs_5EF83E14 } from "../fable_modules/Fable.Remoting.Client.8.0.0/Extensions.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { notFoundView, unauthorizedView } from "../Helpers.jsx";

class Model extends Record {
    constructor(Event$, IsFetchingEvent, Attendees, IsAuthorized, IsRegistering, TasksToComplete, TasksToRevoke) {
        super();
        this.Event = Event$;
        this.IsFetchingEvent = IsFetchingEvent;
        this.Attendees = Attendees;
        this.IsAuthorized = IsAuthorized;
        this.IsRegistering = IsRegistering;
        this.TasksToComplete = TasksToComplete;
        this.TasksToRevoke = TasksToRevoke;
    }
}

function Model_$reflection() {
    return record_type("Event.AttendeesPanel.Model", [], Model, () => [["Event", option_type(Event$_$reflection())], ["IsFetchingEvent", bool_type], ["Attendees", array_type(EventAttendee_$reflection())], ["IsAuthorized", bool_type], ["IsRegistering", bool_type], ["TasksToComplete", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(int32_type, User_$reflection())])], ["TasksToRevoke", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(int32_type, User_$reflection())])]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateEvent", "SetIsFetching", "UpdateAttendees", "UpdateIsAuthorized", "UpdateIsRegistering", "CompleteForAttendee", "RevokeFromAttendee", "AttendeeRemoved", "TaskCompletedForUsers", "TaskRevokedForUsers", "SetFinalized", "SetSignupClosed"];
    }
}

function Msg_$reflection() {
    return union_type("Event.AttendeesPanel.Msg", [], Msg, () => [[["Item", option_type(Event$_$reflection())]], [["Item", bool_type]], [["Item", array_type(EventAttendee_$reflection())]], [["Item", bool_type]], [["Item", bool_type]], [["Item1", EventAttendee_$reflection()], ["Item2", int32_type]], [["Item1", EventAttendee_$reflection()], ["Item2", int32_type]], [["Item", int32_type]], [["Item1", CompletedTask_$reflection()], ["Item2", array_type(User_$reflection())]], [["Item1", int32_type], ["Item2", array_type(User_$reflection())]], [], []]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Event, msg.fields[0], model.Attendees, model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 2:
            return new Model(model.Event, model.IsFetchingEvent, msg.fields[0], model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 3:
            return new Model(model.Event, model.IsFetchingEvent, model.Attendees, msg.fields[0], model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 4: {
            const isRegistering = msg.fields[0];
            if (!isRegistering) {
                return new Model(model.Event, model.IsFetchingEvent, model.Attendees, model.IsAuthorized, isRegistering, empty({
                    Compare: compareArrays,
                }), empty({
                    Compare: compareArrays,
                }));
            }
            else {
                return new Model(model.Event, model.IsFetchingEvent, model.Attendees, model.IsAuthorized, isRegistering, model.TasksToComplete, model.TasksToRevoke);
            }
        }
        case 5: {
            const taskIdToComplete = msg.fields[1] | 0;
            const attendee = msg.fields[0];
            return new Model(model.Event, model.IsFetchingEvent, model.Attendees, model.IsAuthorized, model.IsRegistering, attendee.CompletedTasks.some((task) => (task.Id === taskIdToComplete)) ? model.TasksToComplete : add([taskIdToComplete, attendee.User], model.TasksToComplete), remove([taskIdToComplete, attendee.User], model.TasksToRevoke));
        }
        case 6: {
            const taskIdToRevoke = msg.fields[1] | 0;
            const attendee_1 = msg.fields[0];
            const newTasksToRevoke_1 = attendee_1.CompletedTasks.some((task_1) => (task_1.Id === taskIdToRevoke)) ? add([taskIdToRevoke, attendee_1.User], model.TasksToRevoke) : model.TasksToRevoke;
            return new Model(model.Event, model.IsFetchingEvent, model.Attendees, model.IsAuthorized, model.IsRegistering, remove([taskIdToRevoke, attendee_1.User], model.TasksToComplete), newTasksToRevoke_1);
        }
        case 7:
            return new Model(model.Event, model.IsFetchingEvent, model.Attendees.filter((attendee_2) => (attendee_2.User.Id !== msg.fields[0])), model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 8:
            return new Model(model.Event, model.IsFetchingEvent, map((attendee_3) => {
                if (contains(attendee_3.User, msg.fields[1], {
                    Equals: equals,
                    GetHashCode: safeHash,
                })) {
                    return new EventAttendee(attendee_3.User, append([msg.fields[0].Task], attendee_3.CompletedTasks), attendee_3.TimeSignedUp, attendee_3.Priority);
                }
                else {
                    return attendee_3;
                }
            }, model.Attendees), model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 9:
            return new Model(model.Event, model.IsFetchingEvent, map((attendee_4) => {
                if (contains(attendee_4.User, msg.fields[1], {
                    Equals: equals,
                    GetHashCode: safeHash,
                })) {
                    return new EventAttendee(attendee_4.User, attendee_4.CompletedTasks.filter((task_2) => (task_2.Id !== msg.fields[0])), attendee_4.TimeSignedUp, attendee_4.Priority);
                }
                else {
                    return attendee_4;
                }
            }, model.Attendees), model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 10:
            return new Model(map_1((event_1) => (new Event$(event_1.Id, event_1.Name, event_1.Enabled, event_1.Summary, event_1.Description, event_1.Address, event_1.MaxAttendees, event_1.AttendeeCount, event_1.Time, event_1.EndTime, event_1.SignupDeadline, event_1.DateDescription, true, event_1.Course, event_1.Teacher, event_1.SecondaryTeachers, event_1.Region)), model.Event), model.IsFetchingEvent, model.Attendees, model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 11:
            return new Model(map_1((event_2) => (new Event$(event_2.Id, event_2.Name, event_2.Enabled, event_2.Summary, event_2.Description, event_2.Address, event_2.MaxAttendees, event_2.AttendeeCount, event_2.Time, event_2.EndTime, utcNow(), event_2.DateDescription, event_2.Finalized, event_2.Course, event_2.Teacher, event_2.SecondaryTeachers, event_2.Region)), model.Event), model.IsFetchingEvent, model.Attendees, model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        default:
            return new Model(msg.fields[0], false, model.Attendees, model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
    }
}

function init() {
    return new Model(undefined, true, [], false, false, empty({
        Compare: compareArrays,
    }), empty({
        Compare: compareArrays,
    }));
}

function Promises_fetchEvent(eventId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.Get(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            dispatch(new Msg(1, [false]));
        }
        else {
            const e = res.fields[0];
            dispatch(new Msg(0, [e]));
            if ((e.Teacher.Id === self.Id) ? true : e.SecondaryTeachers.some((t) => (t.Id === self.Id))) {
                dispatch(new Msg(3, [true]));
            }
        }
        return res;
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_fetchAttendees(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.GetAttendees(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(2, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_completeTasks(eventId, tasksToComplete, dispatch, setCtx) {
    let pr_3;
    let pr_2;
    const pr_1 = map((tupledArg) => {
        const users = map((tuple_1) => tuple_1[1], tupledArg[1]);
        const pr = startAsPromise(Task.CompleteCourseTask(tupledArg[0], map((_arg) => _arg.Id, users, Int32Array), eventId));
        return pr.then((res) => Result_Map((task) => {
            let tupledArg_1;
            dispatch((tupledArg_1 = [task, users], new Msg(8, [tupledArg_1[0], tupledArg_1[1]])));
        }, res));
    }, Array_groupBy((tuple) => tuple[0], toArray(tasksToComplete), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }));
    pr_2 = (Promise.all(pr_1));
    pr_3 = (pr_2.then((results) => {
        if (results.some((_arg_1) => {
            if (_arg_1.tag === 0) {
                return false;
            }
            else {
                return true;
            }
        })) {
            errorToast(setCtx, "completeTasksError", "Kunne ikke godkjenne alle oppgaver", "Noe gikk galt med godkjenning av minst én oppgave", undefined);
        }
    }));
    void (pr_3.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_revokeTasks(eventId, tasksToRevoke, dispatch, setCtx) {
    let pr_3;
    let pr_2;
    const pr_1 = map((tupledArg) => {
        const taskId = tupledArg[0] | 0;
        const users = map((tuple_1) => tuple_1[1], tupledArg[1]);
        const pr = startAsPromise(Task.RevokeCourseTask(taskId, map((_arg) => _arg.Id, users, Int32Array), eventId));
        return pr.then((res) => Result_Map(() => {
            let tupledArg_1;
            dispatch((tupledArg_1 = [taskId, users], new Msg(9, [tupledArg_1[0], tupledArg_1[1]])));
        }, res));
    }, Array_groupBy((tuple) => tuple[0], toArray(tasksToRevoke), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }));
    pr_2 = (Promise.all(pr_1));
    pr_3 = (pr_2.then((results) => {
        if (results.some((_arg_1) => {
            if (_arg_1.tag === 0) {
                return false;
            }
            else {
                return true;
            }
        })) {
            errorToast(setCtx, "revokeTasksError", "Kunne ikke underkjenne alle oppgaver", "Noe gikk galt med underkjenning av minst én oppgave", undefined);
        }
    }));
    void (pr_3.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_updateAttendeePriority(eventId, userId, priority, model, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.UpdateAttendeePriority(eventId, userId, priority));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 3: {
                    errorToast(setCtx, `prioritize${userId}Negative`, "Kunne ikke endre prioritet", "Ugyldig prioritet", undefined);
                    break;
                }
                case 1: {
                    errorToast(setCtx, `prioritize${userId}Deadline`, "Kunne ikke endre prioritet", "Påmeldingsfrist er passert", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, `prioritize${userId}Error`, "Kunne ikke endre prioritet", "Noe gikk galt", undefined);
            }
        }
        else {
            dispatch(new Msg(2, [map((attendee) => {
                if (attendee.User.Id === userId) {
                    return res.fields[0];
                }
                else {
                    return attendee;
                }
            }, model.Attendees)]));
            successToast(setCtx, `prioritize${userId}Success`, "Prioritet oppdatert", "");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_removeAttendee(eventId, userId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.RemoveAttendee(eventId, userId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            if (res.fields[0].tag === 2) {
                dispatch(new Msg(7, [userId]));
            }
            else {
                errorToast(setCtx, `removeAttendee${userId}Error`, "Kunne ikke fjerne deltaker", "Noe gikk galt", undefined);
            }
        }
        else {
            dispatch(new Msg(7, [userId]));
            successToast(setCtx, `removeAttendee${userId}Success`, "Deltaker fjernet", "Deltakeren ble fjernet fra kurset");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_finalizeEvent(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.Finalize(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 2: {
                    errorToast(setCtx, `finalize${eventId}NotFinished`, "Kunne ikke ferdigstille", "Kurset er ikke gjennomført enda", undefined);
                    break;
                }
                case 0: {
                    errorToast(setCtx, `finalize${eventId}NotFound`, "Kunne ikke ferdigstille", "Noe gikk galt", undefined);
                    break;
                }
                default: {
                    dispatch(new Msg(10, []));
                    errorToast(setCtx, `finalize${eventId}AlreadyFinalized`, "Kunne ikke ferdigstille", "Arrangementet er allerede markert som ferdigstilt", undefined);
                }
            }
        }
        else {
            dispatch(new Msg(10, []));
            successToast(setCtx, `finalize${eventId}`, "Arrangement ferdigstilt", "Arrangementet ble markert som ferdigstilt");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_closeSignup(eventId, onSuccess, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.CloseSignup(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, `closeSignup${eventId}AlreadyStarted`, "Kan ikke lukke påmelding", "Arrangementet har allerede startet", undefined);
                    break;
                }
                case 3: {
                    errorToast(setCtx, `closeSignup${eventId}Unauthorized`, "Ingen tilgang", "Du har ikke tilgang til å lukke påmeldingen", undefined);
                    break;
                }
                case 0: {
                    errorToast(setCtx, `closeSignup${eventId}NotFound`, "Fant ikke arrangementet", "", undefined);
                    break;
                }
                default: {
                    onSuccess();
                    infoToast(setCtx, `closeSignup${eventId}AlreadySent`, "Allerede lukket", "Påmeldingen er allerede lukket og varsler er sendt", undefined);
                }
            }
        }
        else {
            onSuccess();
            successToast(setCtx, `closeSignup${eventId}`, "Påmelding lukket", "Deltakerne er varslet om plassene sine");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function RemoveAttendeeDialog(removeAttendeeDialogInputProps) {
    let elems_3, el_4, el_2, el, props_43, props_41, el_6, el_14, elems, el_8, el_10, el_12, el_20, elems_1, el_18, el_16, el_26, elems_2, el_24, el_22, name, name_2, elemsToUse;
    const dispatch = removeAttendeeDialogInputProps.dispatch;
    const model = removeAttendeeDialogInputProps.model;
    const attendee = removeAttendeeDialogInputProps.attendee;
    const event = removeAttendeeDialogInputProps.event;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const hasConfirmed = patternInput_1[0];
    const patternInput_2 = useCtx();
    const el_28 = Dialog;
    return createElement(el_28, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_3 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = DeleteRegular, createElement(el, {})),
            appearance: "transparent",
            disabled: model.IsRegistering ? true : (!equals(patternInput_2[0].User.Role, new Role(1, [])) && event.Finalized),
        })),
    })), (props_43 = singleton((props_41 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Fjern deltaker",
    })), (el_14 = DialogContent, createElement(el_14, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_8 = WarningFilled, createElement(el_8, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_10 = Body1Strong, createElement(el_10, {
        style: {
            textAlign: "center",
        },
        children: `Er du sikker på at du vil fjerne ${attendee.User.FirstName} ${attendee.User.LastName} fra dette kurset? Det vil ikke være mulig å angre denne handlingen.`,
    })), (el_12 = Checkbox, createElement(el_12, {
        label: "Ja, jeg er sikker",
        checked: hasConfirmed,
        onChange: (_arg_1, c) => {
            patternInput_1[1](Checkbox_toBool(c));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "start"], (elems_1 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = DismissRegular, createElement(el_16, {})),
        children: "Avbryt",
        onClick: (_arg_2) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_26 = DialogActions, createElement(el_26, createObj(ofArray([["position", "end"], (elems_2 = [(el_24 = Button, createElement(el_24, {
        icon: (el_22 = PersonDeleteRegular, createElement(el_22, {})),
        appearance: "primary",
        children: "Fjern",
        disabled: !hasConfirmed,
        onClick: (_arg_3) => {
            setIsOpen(false);
            Promises_removeAttendee(event.Id, attendee.User.Id, dispatch, patternInput_2[1]);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_41)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_43)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function FinalizeEventDialog(finalizeEventDialogInputProps) {
    let elems_3, props_34, props_32, el, el_8, elems, el_2, el_4, el_6, el_14, elems_1, el_12, el_10, el_20, elems_2, el_18, el_16, name, name_2, elemsToUse;
    const setIsOpen = finalizeEventDialogInputProps.setIsOpen;
    const isOpen = finalizeEventDialogInputProps.isOpen;
    const dispatch = finalizeEventDialogInputProps.dispatch;
    const event = finalizeEventDialogInputProps.event;
    const patternInput = reactApi.useState(false);
    const hasConfirmed = patternInput[0];
    const patternInput_1 = useCtx();
    const el_22 = Dialog;
    return createElement(el_22, createObj(ofArray([["open", isOpen], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_3 = [(props_34 = singleton((props_32 = ofArray([(el = DialogTitle, createElement(el, {
        children: "Ferdigstill kurs",
    })), (el_8 = DialogContent, createElement(el_8, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_2 = WarningFilled, createElement(el_2, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_4 = Body1Strong, createElement(el_4, {
        style: {
            textAlign: "center",
        },
        children: `Er du sikker på at du vil ferdigstille ${event.Name}? Det vil ikke lenger være mulig å redigere på registrering av oppmøte og øvrige oppgaver.`,
    })), (el_6 = Checkbox, createElement(el_6, {
        label: "Ja, jeg er sikker",
        checked: hasConfirmed,
        onChange: (_arg_1, c) => {
            patternInput[1](Checkbox_toBool(c));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_14 = DialogActions, createElement(el_14, createObj(ofArray([["position", "start"], (elems_1 = [(el_12 = Button, createElement(el_12, {
        icon: (el_10 = DismissRegular, createElement(el_10, {})),
        children: "Avbryt",
        onClick: (_arg_2) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "end"], (elems_2 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = DocumentLockRegular, createElement(el_16, {})),
        appearance: "primary",
        children: "Ferdigstill",
        disabled: !hasConfirmed,
        onClick: (_arg_3) => {
            setIsOpen(false);
            Promises_finalizeEvent(event.Id, dispatch, patternInput_1[1]);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_32)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_34)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

export function canCloseSignup(event) {
    if (compare(event.SignupDeadline, now()) > 0) {
        return compare(event.Time, now()) > 0;
    }
    else {
        return false;
    }
}

export function CloseSignupDialog(closeSignupDialogInputProps) {
    let elems_3, props_34, props_32, el, el_8, elems, el_2, el_4, el_6, el_14, elems_1, el_12, el_10, el_20, elems_2, el_18, el_16, name, name_2, elemsToUse;
    const setIsOpen = closeSignupDialogInputProps.setIsOpen;
    const isOpen = closeSignupDialogInputProps.isOpen;
    const onClosed = closeSignupDialogInputProps.onClosed;
    const event = closeSignupDialogInputProps.event;
    const patternInput = useCtx();
    if (!canCloseSignup(event)) {
        return defaultOf();
    }
    else {
        const el_22 = Dialog;
        return createElement(el_22, createObj(ofArray([["open", isOpen], ["onOpenChange", (_arg, value_1_1) => {
            setIsOpen(value_1_1.open);
        }], (elems_3 = [(props_34 = singleton((props_32 = ofArray([(el = DialogTitle, createElement(el, {
            children: "Lukk påmelding",
        })), (el_8 = DialogContent, createElement(el_8, createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 5 + "px ",
            marginBottom: 10,
        }], (elems = [(el_2 = WarningFilled, createElement(el_2, {
            primaryFill: tokens.colorStatusWarningForeground1,
            fontSize: 48,
        })), (el_4 = Body1Strong, createElement(el_4, {
            style: {
                textAlign: "center",
            },
            children: `Lukker påmeldingen for ${event.Name} nå og sender ut varsler om plasser/venteliste til alle påmeldte.`,
        })), (el_6 = Caption1, createElement(el_6, {
            style: {
                textAlign: "center",
            },
            children: "Dette kan ikke angres. Brukere som ikke har påmeldt seg innen nå vil havne på venteliste.",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_14 = DialogActions, createElement(el_14, createObj(ofArray([["position", "start"], (elems_1 = [(el_12 = Button, createElement(el_12, {
            icon: (el_10 = DismissRegular, createElement(el_10, {})),
            children: "Avbryt",
            onClick: (_arg_1) => {
                setIsOpen(false);
            },
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "end"], (elems_2 = [(el_18 = Button, createElement(el_18, {
            icon: (el_16 = LockClosedRegular, createElement(el_16, {})),
            appearance: "primary",
            children: "Lukk og varsle",
            onClick: (_arg_2) => {
                setIsOpen(false);
                Promises_closeSignup(event.Id, () => {
                    onClosed(new Event$(event.Id, event.Name, event.Enabled, event.Summary, event.Description, event.Address, event.MaxAttendees, event.AttendeeCount, event.Time, event.EndTime, utcNow(), event.DateDescription, event.Finalized, event.Course, event.Teacher, event.SecondaryTeachers, event.Region));
                }, patternInput[1]);
            },
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
            children: reactApi.Children.toArray(Array.from(props_32)),
        })))), (name_2 = DialogSurface, createElement(name_2, {
            children: reactApi.Children.toArray(Array.from(props_34)),
        })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
    }
}

function MobileAttendeeDialog(mobileAttendeeDialogInputProps) {
    let elems_9, props_66, props_64, el_6, elems_2, elems_1, el_2, el_4, el_36, elems_7, el_40, elems_8, el_38, name_12, name_14, elemsToUse;
    const setIsOpen = mobileAttendeeDialogInputProps.setIsOpen;
    const isOpen = mobileAttendeeDialogInputProps.isOpen;
    const dispatch = mobileAttendeeDialogInputProps.dispatch;
    const model = mobileAttendeeDialogInputProps.model;
    const isConfirmed = mobileAttendeeDialogInputProps.isConfirmed;
    const attendee = mobileAttendeeDialogInputProps.attendee;
    const event = mobileAttendeeDialogInputProps.event;
    const patternInput = useCtx();
    const fullName = `${attendee.User.FirstName} ${attendee.User.LastName}`;
    const updatePriority = (newPriority) => {
        Promises_updateAttendeePriority(event.Id, attendee.User.Id, newPriority, model, dispatch, patternInput[1]);
    };
    const deadlinePassed = compare(event.SignupDeadline, now()) <= 0;
    const labelledRow = (label, value) => {
        let elems, el;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Caption1, createElement(el, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: label,
        })), value], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    const el_42 = Dialog;
    return createElement(el_42, createObj(ofArray([["open", isOpen], ["onOpenChange", (_arg, value_1_3) => {
        setIsOpen(value_1_3.open);
    }], (elems_9 = [(props_66 = singleton((props_64 = ofArray([(el_6 = DialogTitle, createElement(el_6, createObj(singleton((elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 8 + "px ",
        alignItems: "center",
    }], (elems_1 = [(el_2 = Avatar, createElement(el_2, {
        color: "colorful",
        name: fullName,
        image: {
            src: defaultArg(attendee.User.ThumbnailUrl, ""),
        },
    })), (el_4 = Subtitle1, createElement(el_4, {
        children: fullName,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))]))))), (el_36 = DialogContent, createElement(el_36, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 12 + "px ",
    }], (elems_7 = toList(delay(() => {
        let el_8, el_10;
        return append_1(isConfirmed ? singleton_1((el_8 = Badge, createElement(el_8, {
            appearance: "tint",
            color: "success",
            children: "Bekreftet plass",
        }))) : singleton_1((el_10 = Badge, createElement(el_10, {
            appearance: "tint",
            color: "warning",
            children: "Venteliste",
        }))), delay(() => {
            let el_12;
            return append_1(singleton_1(labelledRow("Kommune/Arbeidsplass", (el_12 = Text$, createElement(el_12, {
                children: defaultArg(map_1((wp) => (`${wp.Municipality}/${wp.Name}`), attendee.User.Workplace), "—"),
            })))), delay(() => {
                let el_14, locale, formatOptions;
                return append_1(singleton_1(labelledRow("Dato Påmeldt", (el_14 = Text$, createElement(el_14, {
                    children: (locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(attendee.TimeSignedUp, "dd MMM yyyy", formatOptions)))),
                })))), delay(() => {
                    let elems_4;
                    return append_1((event.Course.Tasks.length > 0) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 5 + "px ",
                    }], (elems_4 = toList(delay(() => {
                        let el_16;
                        return append_1(singleton_1((el_16 = Caption1, createElement(el_16, {
                            style: {
                                color: tokens.colorNeutralForeground3,
                            },
                            children: "Oppgaver",
                        }))), delay(() => map((task) => {
                            let elems_3;
                            const isCompleted = contains_1([task.Id, attendee.User], model.TasksToComplete) ? true : (contains_1([task.Id, attendee.User], model.TasksToRevoke) ? false : contains(task, attendee.CompletedTasks, {
                                Equals: equals,
                                GetHashCode: safeHash,
                            }));
                            if (model.IsRegistering) {
                                const el_18 = Checkbox;
                                return createElement(el_18, {
                                    label: task.VerificationRequired ? (`${task.Name} *`) : task.Name,
                                    checked: isCompleted,
                                    onChange: (_arg_1, c) => {
                                        let tupledArg, tupledArg_1;
                                        const _b = Checkbox_toBool(c);
                                        if (isCompleted) {
                                            dispatch((tupledArg = [attendee, task.Id], new Msg(6, [tupledArg[0], tupledArg[1]])));
                                        }
                                        else {
                                            dispatch((tupledArg_1 = [attendee, task.Id], new Msg(5, [tupledArg_1[0], tupledArg_1[1]])));
                                        }
                                    },
                                });
                            }
                            else {
                                return createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    gap: 5 + "px ",
                                    alignItems: "center",
                                }], (elems_3 = toList(delay(() => {
                                    let el_20, el_22;
                                    return append_1(isCompleted ? singleton_1((el_20 = CheckmarkFilled, createElement(el_20, {
                                        primaryFill: tokens.colorStatusSuccessForeground1,
                                    }))) : singleton_1((el_22 = DismissFilled, createElement(el_22, {
                                        primaryFill: tokens.colorStatusDangerForeground1,
                                    }))), delay(() => {
                                        let el_24;
                                        return singleton_1((el_24 = Text$, createElement(el_24, {
                                            children: task.Name,
                                        })));
                                    }));
                                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                            }
                        }, event.Course.Tasks)));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty_1(), delay(() => {
                        let elems_5, el_26, el_30, el_28, el_34, el_32;
                        return append_1(singleton_1(labelledRow("Prioritet", createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            gap: 8 + "px ",
                            alignItems: "center",
                        }], (elems_5 = [(el_26 = Body1Strong, createElement(el_26, {
                            children: `${attendee.Priority}`,
                        })), (el_30 = Button, createElement(el_30, {
                            icon: (el_28 = ChevronUpRegular, createElement(el_28, {})),
                            children: "Opp",
                            disabled: deadlinePassed ? true : model.IsRegistering,
                            onClick: (_arg_2) => {
                                updatePriority(attendee.Priority + 1);
                            },
                        })), (el_34 = Button, createElement(el_34, {
                            icon: (el_32 = ChevronDownRegular, createElement(el_32, {})),
                            children: "Ned",
                            disabled: ((attendee.Priority <= 0) ? true : deadlinePassed) ? true : model.IsRegistering,
                            onClick: (_arg_3) => {
                                updatePriority(attendee.Priority - 1);
                            },
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))))), delay(() => {
                            let elems_6;
                            return singleton_1(createElement("div", createObj(ofArray([["style", {
                                marginTop: 5,
                            }], (elems_6 = [createElement(RemoveAttendeeDialog, {
                                event: event,
                                attendee: attendee,
                                model: model,
                                dispatch: dispatch,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])))), (el_40 = DialogActions, createElement(el_40, createObj(singleton((elems_8 = [(el_38 = Button, createElement(el_38, {
        children: "Lukk",
        onClick: (_arg_4) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])))))]), (name_12 = DialogBody, createElement(name_12, {
        children: reactApi.Children.toArray(Array.from(props_64)),
    })))), (name_14 = DialogSurface, createElement(name_14, {
        children: reactApi.Children.toArray(Array.from(props_66)),
    })))], (elemsToUse = ((length(elems_9) <= 2) ? elems_9 : take(2, elems_9)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function Table(tableInputProps) {
    const dispatch = tableInputProps.dispatch;
    const model = tableInputProps.model;
    const event = tableInputProps.event;
    const patternInput = useCtx();
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const patternInput_1 = reactApi.useState(["priority", new SortDirection(1, [])]);
    const patternInput_2 = reactApi.useState(false);
    const setDialogIsOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const confirmedUserIds = ofArray_1(map((a_1) => a_1.User.Id, truncate(event.MaxAttendees, sortWith((a, b) => {
        if (a.Priority !== b.Priority) {
            return comparePrimitives(b.Priority, a.Priority) | 0;
        }
        else {
            return compare(a.TimeSignedUp, b.TimeSignedUp) | 0;
        }
    }, model.Attendees)), Int32Array), {
        Compare: comparePrimitives,
    });
    const columns = toList(delay(() => {
        let createTableColumn;
        return append_1(singleton_1((createTableColumn = createTableColumn_7, createTableColumn({
            columnId: "name",
            compare: (delegateArg, delegateArg_1) => {
                const a_2 = delegateArg;
                const b_1 = delegateArg_1;
                return compare_1(`${a_2.User.FirstName} ${a_2.User.LastName}`, `${b_1.User.FirstName} ${b_1.User.LastName}`) | 0;
            },
            renderHeaderCell: () => "Deltaker",
            renderCell: (delegateArg_3) => {
                let elems, el, el_2;
                const attendee = delegateArg_3;
                const name = `${attendee.User.FirstName} ${attendee.User.LastName}`;
                const el_4 = Link;
                return createElement(el_4, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(attendee.User.Id)]), 1)], ["onClick", (e) => {
                    e.stopPropagation();
                }], ["style", {
                    display: "flex",
                    gap: 5 + "px ",
                    alignItems: "center",
                    minWidth: 0,
                    overflow: "hidden",
                    textDecoration: "none",
                    color: tokens.colorNeutralForeground1,
                }], (elems = [(el = Avatar, createElement(el, createObj(toList(delay(() => append_1(singleton_1(["color", "colorful"]), delay(() => append_1(singleton_1(["name", name]), delay(() => append_1(isMobile ? singleton_1(["size", 24]) : empty_1(), delay(() => singleton_1(["image", {
                    src: defaultArg(attendee.User.ThumbnailUrl, ""),
                }])))))))))))), (el_2 = Text$, createElement(el_2, createObj(toList(delay(() => append_1(singleton_1(["children", name]), delay(() => append_1(singleton_1(["wrap", false]), delay(() => append_1(isMobile ? singleton_1(["size", 200]) : empty_1(), delay(() => singleton_1(["style", {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    minWidth: 0,
                }]))))))))))))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
            },
        }))), delay(() => {
            let createTableColumn_1;
            return append_1(singleton_1((createTableColumn_1 = createTableColumn_7, createTableColumn_1({
                columnId: "status",
                renderHeaderCell: () => "Status",
                compare: (delegateArg_5, delegateArg_1_1) => {
                    const aConfirmed = contains_1(delegateArg_5.User.Id, confirmedUserIds);
                    return comparePrimitives(contains_1(delegateArg_1_1.User.Id, confirmedUserIds), aConfirmed) | 0;
                },
                renderCell: (delegateArg_6) => {
                    if (contains_1(delegateArg_6.User.Id, confirmedUserIds)) {
                        const el_6 = Badge;
                        return createElement(el_6, {
                            appearance: "tint",
                            color: "success",
                            children: "Bekreftet plass",
                        });
                    }
                    else {
                        const el_8 = Badge;
                        return createElement(el_8, {
                            appearance: "tint",
                            color: "warning",
                            children: "Venteliste",
                        });
                    }
                },
            }))), delay(() => {
                let createTableColumn_2;
                return append_1(!isMobile ? append_1(singleton_1((createTableColumn_2 = createTableColumn_7, createTableColumn_2({
                    columnId: "signedUp",
                    renderHeaderCell: () => "Dato Påmeldt",
                    compare: (delegateArg_8, delegateArg_1_2) => compareTo(delegateArg_1_2.TimeSignedUp, delegateArg_8.TimeSignedUp),
                    renderCell: (delegateArg_9) => {
                        const locale = nb;
                        const formatOptions = {};
                        formatOptions.locale = locale;
                        return format_1(delegateArg_9.TimeSignedUp, "dd MMM yyyy", formatOptions);
                    },
                }))), delay(() => {
                    let createTableColumn_3;
                    return singleton_1((createTableColumn_3 = createTableColumn_7, createTableColumn_3({
                        columnId: "municipality",
                        renderHeaderCell: () => "kommune/arbeidsplass",
                        compare: (delegateArg_11, delegateArg_1_3) => compareTo_1(defaultArg(map_1((wp) => (`${wp.Municipality}/${wp.Name}`), delegateArg_11.User.Workplace), ""), defaultArg(map_1((wp_1) => (`${wp_1.Municipality}/${wp_1.Name}`), delegateArg_1_3.User.Workplace), "")),
                        renderCell: (delegateArg_12) => defaultArg(map_1((wp_2) => (`${wp_2.Municipality}/${wp_2.Name}`), delegateArg_12.User.Workplace), ""),
                    })));
                })) : empty_1(), delay(() => (!isMobile ? append_1(map((task) => {
                    const createTableColumn_4 = createTableColumn_7;
                    return createTableColumn_4({
                        columnId: `task-${task.Id}`,
                        renderHeaderCell: () => {
                            const el_10 = Field;
                            return createElement(el_10, {
                                required: task.VerificationRequired,
                                label: `${task.Name}`,
                            });
                        },
                        renderCell: (delegateArg_14) => {
                            const attendee_4 = delegateArg_14;
                            const isCompleted = contains_1([task.Id, attendee_4.User], model.TasksToComplete) ? true : (contains_1([task.Id, attendee_4.User], model.TasksToRevoke) ? false : contains(task, attendee_4.CompletedTasks, {
                                Equals: equals,
                                GetHashCode: safeHash,
                            }));
                            if (model.IsRegistering) {
                                const el_12 = Checkbox;
                                return createElement(el_12, {
                                    checked: isCompleted,
                                    onChange: (_arg_5, c) => {
                                        let tupledArg, tupledArg_1;
                                        const _b = Checkbox_toBool(c);
                                        if (isCompleted) {
                                            dispatch((tupledArg = [attendee_4, task.Id], new Msg(6, [tupledArg[0], tupledArg[1]])));
                                        }
                                        else {
                                            dispatch((tupledArg_1 = [attendee_4, task.Id], new Msg(5, [tupledArg_1[0], tupledArg_1[1]])));
                                        }
                                    },
                                });
                            }
                            else if (isCompleted) {
                                const el_14 = CheckmarkFilled;
                                return createElement(el_14, {
                                    primaryFill: tokens.colorStatusSuccessForeground1,
                                });
                            }
                            else {
                                const el_16 = DismissFilled;
                                return createElement(el_16, {
                                    primaryFill: tokens.colorStatusDangerForeground1,
                                });
                            }
                        },
                    });
                }, event.Course.Tasks), delay(() => {
                    let createTableColumn_5;
                    return append_1(singleton_1((createTableColumn_5 = createTableColumn_7, createTableColumn_5({
                        columnId: "priority",
                        renderHeaderCell: () => "Prioritet",
                        compare: (delegateArg_16, delegateArg_1_4) => {
                            const a_6 = delegateArg_16;
                            const b_5 = delegateArg_1_4;
                            if (a_6.Priority < b_5.Priority) {
                                return -1;
                            }
                            else if (a_6.Priority > b_5.Priority) {
                                return 1;
                            }
                            else {
                                return compareTo(b_5.TimeSignedUp, a_6.TimeSignedUp) | 0;
                            }
                        },
                        renderCell: (delegateArg_17) => {
                            let elems_3, el_18, el_27, el_20, matchValue, el_24, el_22, el_36, el_29, matchValue_1, el_33, el_31;
                            const attendee_5 = delegateArg_17;
                            const updatePriority = (newPriority) => {
                                Promises_updateAttendeePriority(event.Id, attendee_5.User.Id, newPriority, model, dispatch, patternInput[1]);
                            };
                            return createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                alignItems: "center",
                                gap: 5 + "px ",
                            }], (elems_3 = [(el_18 = Text$, createElement(el_18, {
                                children: `${attendee_5.Priority}`,
                            })), (el_27 = Tooltip, createElement(el_27, createObj(ofArray([["content", (el_20 = Text$, createElement(el_20, {
                                children: "Justér opp",
                            }))], (matchValue = tryHead([(el_24 = Button, createElement(el_24, {
                                size: "small",
                                appearance: "subtle",
                                icon: (el_22 = ChevronUpRegular, createElement(el_22, {})),
                                disabled: (compare(event.SignupDeadline, now()) <= 0) ? true : model.IsRegistering,
                                onClick: (_arg_7) => {
                                    updatePriority(attendee_5.Priority + 1);
                                },
                            }))]), (matchValue == null) ? ["children", defaultOf()] : ["children", matchValue])])))), (el_36 = Tooltip, createElement(el_36, createObj(ofArray([["content", (el_29 = Text$, createElement(el_29, {
                                children: "Justér ned",
                            }))], (matchValue_1 = tryHead([(el_33 = Button, createElement(el_33, {
                                size: "small",
                                appearance: "subtle",
                                icon: (el_31 = ChevronDownRegular, createElement(el_31, {})),
                                disabled: ((attendee_5.Priority <= 0) ? true : (compare(event.SignupDeadline, now()) <= 0)) ? true : model.IsRegistering,
                                onClick: (_arg_8) => {
                                    updatePriority(attendee_5.Priority - 1);
                                },
                            }))]), (matchValue_1 == null) ? ["children", defaultOf()] : ["children", matchValue_1])]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                        },
                    }))), delay(() => {
                        let createTableColumn_6;
                        return singleton_1((createTableColumn_6 = createTableColumn_7, createTableColumn_6({
                            columnId: "remove",
                            renderHeaderCell: () => "",
                            renderCell: (delegateArg_19) => {
                                let matchValue_2, children;
                                const el_39 = Tooltip;
                                return createElement(el_39, createObj(ofArray([["content", "Fjern deltaker"], (matchValue_2 = tryHead([(children = singleton(createElement(RemoveAttendeeDialog, {
                                    event: event,
                                    attendee: delegateArg_19,
                                    model: model,
                                    dispatch: dispatch,
                                })), createElement("div", {
                                    children: reactApi.Children.toArray(Array.from(children)),
                                }))]), (matchValue_2 == null) ? ["children", defaultOf()] : ["children", matchValue_2])])));
                            },
                        })));
                    }));
                })) : empty_1())));
            }));
        }));
    }));
    const dialogAttendee = bind((uid) => tryFind((a_7) => (a_7.User.Id === uid), model.Attendees), patternInput_3[0]);
    const xs_1 = toList(delay(() => {
        let el_49;
        return append_1(singleton_1((el_49 = DataGrid, createElement(el_49, createObj(toList(delay(() => append_1(singleton_1(dataGrid_items_Z6D8BD2B8(model.Attendees)), delay(() => append_1(singleton_1(["columns", toArray_1(columns)]), delay(() => append_1(singleton_1(["sortable", true]), delay(() => {
            let tupledArg_2;
            return append_1(singleton_1((tupledArg_2 = patternInput_1[0], ["sortState", {
                sortColumn: unwrap(tupledArg_2[0]),
                sortDirection: tupledArg_2[1],
            }])), delay(() => append_1(singleton_1(["onSortChange", (delegateArg_20, delegateArg_1_5) => {
                const sortState_1 = delegateArg_1_5;
                patternInput_1[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
            }]), delay(() => append_1(singleton_1(["getRowId", (delegateArg_21) => delegateArg_21.User.Id]), delay(() => append_1(isMobile ? append_1(singleton_1(["size", "small"]), delay(() => append_1(singleton_1(["selectionMode", "single"]), delay(() => append_1(singleton_1(["selectedItems", empty_2()]), delay(() => append_1(singleton_1(["subtleSelection", true]), delay(() => singleton_1(["onSelectionChange", (_arg_11, value_1_54) => {
                const matchValue_3 = TempSeq_mkOnChangeData(value_1_54).selectedItems;
                let matchResult, userId;
                if (!isEmpty(matchValue_3)) {
                    if (isEmpty(tail(matchValue_3))) {
                        matchResult = 0;
                        userId = head(matchValue_3);
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        patternInput_3[1](userId);
                        setDialogIsOpen(true);
                        break;
                    }
                    case 1: {
                        break;
                    }
                }
            }]))))))))) : empty_1(), delay(() => {
                let elems_6, props_61, el_41, name_7, el_47;
                return singleton_1((elems_6 = [(props_61 = singleton((el_41 = DataGridRow, createElement(el_41, createObj(toList(delay(() => append_1(isMobile ? singleton_1(["selectionCell", defaultOf()]) : empty_1(), delay(() => singleton_1(["children", (delegateArg_22, delegateArg_1_6) => {
                    const props_56 = singleton(delegateArg_22.renderHeaderCell());
                    const name_5 = DataGridHeaderCell;
                    return createElement(name_5, {
                        children: reactApi.Children.toArray(Array.from(props_56)),
                    });
                }]))))))))), (name_7 = DataGridHeader, createElement(name_7, {
                    children: reactApi.Children.toArray(Array.from(props_61)),
                }))), (el_47 = DataGridBody, createElement(el_47, {
                    children: (delegateArg_24) => {
                        const trd = delegateArg_24;
                        const el_45 = DataGridRow;
                        return createElement(el_45, createObj(toList(delay(() => append_1(singleton_1(["key", trd.rowId]), delay(() => append_1(isMobile ? singleton_1(["selectionCell", defaultOf()]) : empty_1(), delay(() => singleton_1(["children", (delegateArg_23, delegateArg_1_7) => {
                            let elems_5;
                            const tcd_1 = delegateArg_23;
                            const el_43 = DataGridCell;
                            return createElement(el_43, createObj(ofArray([["key", tcd_1.columnId], (elems_5 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
                        }])))))))));
                    },
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))]));
            }))))))));
        })))))))))))), delay(() => {
            const matchValue_4 = dialogAttendee;
            if (matchValue_4 == null) {
                return singleton_1(defaultOf());
            }
            else {
                const attendee_7 = matchValue_4;
                return singleton_1(createElement(MobileAttendeeDialog, {
                    event: event,
                    attendee: attendee_7,
                    isConfirmed: contains_1(attendee_7.User.Id, confirmedUserIds),
                    model: model,
                    dispatch: dispatch,
                    isOpen: patternInput_2[0],
                    setIsOpen: setDialogIsOpen,
                }));
            }
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

function AttendeesCard(attendeesCardInputProps) {
    let el, el_4, el_8, el_12, elems_1, el_20, el_18, el_16, el_42, elems, props_63, name, elemsToUse, elems_10, el_74, el_46, elems_3, elems_9, elems_6, el_72, elems_8, el_60, el_58, el_56, el_70, elems_7, el_62, text_4, el_64, el_66, text_6, el_68, elemsToUse_1;
    const dispatch = attendeesCardInputProps.dispatch;
    const model = attendeesCardInputProps.model;
    const event = attendeesCardInputProps.event;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const patternInput_1 = reactApi.useState(false);
    const setFinalizeOpen = patternInput_1[1];
    const saveRegistration = () => {
        Promises_completeTasks(event.Id, model.TasksToComplete, dispatch, setCtx);
        Promises_revokeTasks(event.Id, model.TasksToRevoke, dispatch, setCtx);
        dispatch(new Msg(4, [false]));
    };
    const canFinalize = equals(ctx.User.Role, new Role(1, [])) ? true : !event.Finalized;
    const startRegistrationDisabled = !equals(ctx.User.Role, new Role(1, [])) && event.Finalized;
    let startRegisterButton;
    const el_2 = Button;
    startRegisterButton = createElement(el_2, {
        icon: (el = ClipboardTaskListLtrRegular, createElement(el, {})),
        children: "Start registrering",
        appearance: "primary",
        onClick: (_arg) => {
            dispatch(new Msg(4, [true]));
        },
        disabled: startRegistrationDisabled,
    });
    let finalizeButton;
    const el_6 = Button;
    finalizeButton = createElement(el_6, {
        icon: (el_4 = DocumentLockRegular, createElement(el_4, {})),
        children: "Ferdigstill",
        appearance: "primary",
        disabled: event.Finalized,
        onClick: (_arg_1) => {
            setFinalizeOpen(true);
        },
    });
    let cancelRegisterButton;
    const el_10 = Button;
    cancelRegisterButton = createElement(el_10, {
        icon: (el_8 = DismissRegular, createElement(el_8, {})),
        children: "Avbryt",
        onClick: (_arg_2) => {
            dispatch(new Msg(4, [false]));
        },
    });
    let saveRegisterButton;
    const el_14 = Button;
    saveRegisterButton = createElement(el_14, {
        icon: (el_12 = SaveRegular, createElement(el_12, {})),
        children: "Lagre",
        appearance: "primary",
        onClick: (_arg_3) => {
            saveRegistration();
        },
    });
    let overflowMenu;
    const el_44 = Menu;
    overflowMenu = createElement(el_44, createObj(ofArray([["positioning", {
        position: "below",
        align: "end",
    }], (elems_1 = [(el_20 = MenuTrigger, createElement(el_20, {
        children: (el_18 = Button, createElement(el_18, {
            icon: (el_16 = MoreVerticalRegular, createElement(el_16, {})),
            appearance: "subtle",
        })),
    })), (el_42 = MenuPopover, createElement(el_42, createObj(singleton((elems = [(props_63 = toList(delay(() => {
        let el_24, el_22, el_36, el_34;
        return !model.IsRegistering ? append_1(singleton_1((el_24 = MenuItem, createElement(el_24, {
            icon: (el_22 = DocumentArrowDownRegular, createElement(el_22, {})),
            children: "Eksportér regneark",
            onClick: (_arg_4) => {
                const pr = tap((res) => {
                    if (res.tag === 1) {
                        errorToast(setCtx, "", "Noe gikk galt", `${res.fields[0]}`, undefined);
                    }
                    else {
                        ByteArrayExtensions_SaveFileAs_5EF83E14(res.fields[0], `${event.Name}.xlsx`);
                    }
                }, startAsPromise(Report.EventAttendees(event.Id)));
                void (pr.catch((ex) => {
                    toastServerError(setCtx, ex);
                }));
            },
        }))), delay(() => {
            let el_28, el_26;
            return append_1(singleton_1((el_28 = MenuItem, createElement(el_28, {
                icon: (el_26 = ClipboardTaskListLtrRegular, createElement(el_26, {})),
                children: "Start registrering",
                disabled: startRegistrationDisabled,
                onClick: (_arg_5) => {
                    dispatch(new Msg(4, [true]));
                },
            }))), delay(() => {
                let el_32, el_30;
                return singleton_1((el_32 = MenuItem, createElement(el_32, {
                    icon: (el_30 = DocumentLockRegular, createElement(el_30, {})),
                    children: "Ferdigstill",
                    disabled: !canFinalize,
                    onClick: (_arg_6) => {
                        setFinalizeOpen(true);
                    },
                })));
            }));
        })) : append_1(singleton_1((el_36 = MenuItem, createElement(el_36, {
            icon: (el_34 = SaveRegular, createElement(el_34, {})),
            children: "Lagre",
            onClick: (_arg_7) => {
                saveRegistration();
            },
        }))), delay(() => {
            let el_40, el_38;
            return singleton_1((el_40 = MenuItem, createElement(el_40, {
                icon: (el_38 = DismissRegular, createElement(el_38, {})),
                children: "Avbryt",
                onClick: (_arg_8) => {
                    dispatch(new Msg(4, [false]));
                },
            })));
        }));
    })), (name = MenuList, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_63)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems))])))))], (elemsToUse = ((length(elems_1) <= 2) ? elems_1 : take(2, elems_1)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
    const el_76 = Card;
    return createElement(el_76, createObj(ofArray([["size", "large"], (elems_10 = [(el_74 = CardHeader, createElement(el_74, {
        image: (el_46 = PeopleAudienceRegular, createElement(el_46, {
            fontSize: 32,
        })),
        header: createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems_3 = toList(delay(() => {
            let el_48;
            return append_1(singleton_1((el_48 = Subtitle2, createElement(el_48, {
                children: `Deltakerliste · ${model.Attendees.length} personer`,
            }))), delay(() => {
                let elems_2, el_50, el_52;
                return event.Course.Tasks.some((_arg_9) => _arg_9.VerificationRequired) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 5 + "px ",
                }], (elems_2 = [(el_50 = Caption1, createElement(el_50, {
                    style: {
                        color: tokens.colorStatusDangerForeground1,
                    },
                    children: "*",
                })), (el_52 = Caption1, createElement(el_52, {
                    children: "Må godkjennes av kursleder",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_1();
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))),
        action: createElement("div", createObj(ofArray([["style", {
            display: "flex",
            gap: 5 + "px ",
            alignItems: "start",
            flexWrap: "wrap",
            justifyContent: "flex-end",
        }], (elems_9 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            minHeight: 50,
            gap: 5 + "px ",
        }], (elems_6 = toList(delay(() => append_1(isMobile ? singleton_1(overflowMenu) : (!model.IsRegistering ? singleton_1(createElement("div", {
            style: {
                display: "flex",
                gap: 5 + "px ",
                flexWrap: "wrap",
            },
            children: reactApi.Children.toArray([startRegisterButton, finalizeButton]),
        })) : singleton_1(createElement("div", {
            style: {
                display: "flex",
                gap: 5 + "px ",
                flexWrap: "wrap",
            },
            children: reactApi.Children.toArray([cancelRegisterButton, saveRegisterButton]),
        }))), delay(() => {
            let el_54;
            return (model.IsRegistering && (!isEmpty_1(model.TasksToComplete) ? true : !isEmpty_1(model.TasksToRevoke))) ? singleton_1((el_54 = Caption2, createElement(el_54, {
                children: `${FSharpSet__get_Count(model.TasksToComplete)} godkjennes og ${FSharpSet__get_Count(model.TasksToRevoke)} underkjennes`,
            }))) : empty_1();
        })))), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), (el_72 = Popover, createElement(el_72, createObj(ofArray([["positioning", "before"], (elems_8 = [(el_60 = PopoverTrigger, createElement(el_60, {
            children: (el_58 = Button, createElement(el_58, {
                icon: (el_56 = QuestionRegular, createElement(el_56, {})),
                appearance: "subtle",
            })),
        })), (el_70 = PopoverSurface, createElement(el_70, createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            maxWidth: 400 + "px",
        }], (elems_7 = [(el_62 = Subtitle2, createElement(el_62, {
            children: "Prioritet",
        })), (text_4 = "Deltakere kan prioriteres over andre for å avgjøre hvem som havner på venteliste om kurset blir fullt. Ved påmelding utdeles automatisk en prioritet avhengig av om en deltaker allerede har fått kurset godkjent; 0 hvis godkjent og 1 ellers.", (el_64 = Caption1, createElement(el_64, {
            children: text_4,
        }))), (el_66 = Subtitle2, createElement(el_66, {
            children: "Ferdigstillelse",
        })), (text_6 = "Når kurset er ferdig registert skal det ferdigstilles. Dette indikerer at oppmøte og øvrige\n                        oppgaver er ferdig utfylt og korrekt, og klar for å kontrolleres av administrator. Registreringer kan\n                        ikke redigeres etter ferdigstillelse.", (el_68 = Caption1, createElement(el_68, {
            children: text_6,
        })))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])]))))], (elemsToUse_1 = ((length(elems_8) <= 2) ? elems_8 : take(2, elems_8)), ["children", reactApi_1.Children.toArray(elemsToUse_1)]))]))))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))),
    })), createElement(Table, {
        event: event,
        model: model,
        dispatch: dispatch,
    }), createElement(FinalizeEventDialog, {
        event: event,
        dispatch: dispatch,
        isOpen: patternInput_1[0],
        setIsOpen: setFinalizeOpen,
    })], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])])));
}

export function Panel(panelInputProps) {
    let elems, el, el_2;
    const eventId = panelInputProps.eventId;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        Promises_fetchEvent(eventId, ctx.User, dispatch, setCtx);
        Promises_fetchAttendees(eventId, dispatch, setCtx);
        if (equals(ctx.User.Role, new Role(1, []))) {
            dispatch(new Msg(3, [true]));
        }
    });
    const matchValue = model_1.Event;
    if (matchValue != null) {
        const event = matchValue;
        if (!model_1.IsAuthorized) {
            return unauthorizedView();
        }
        else {
            return createElement(AttendeesCard, {
                event: event,
                model: model_1,
                dispatch: dispatch,
            });
        }
    }
    else if (model_1.IsFetchingEvent) {
        const el_4 = Skeleton;
        return createElement(el_4, createObj(ofArray([["style", {
            width: 100 + "%",
            display: "flex",
            flexDirection: "column",
            gap: 25 + "px ",
        }], (elems = [(el = SkeletonItem, createElement(el, {
            style: {
                height: 5 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        })), (el_2 = SkeletonItem, createElement(el_2, {
            style: {
                height: 40 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }
    else {
        return notFoundView();
    }
}

//# sourceMappingURL=AttendeesPanel.jsx.map
